export const renewPasswordGtmTags = {
	virtualURL: "/force_reset_password",
	virtualTitle: "Force Reset Password",
	lobby: "false",
	lobbyName: "LOGIN",
	subArea: "Force_Reset_Password",
	formName: "Force_Reset_password",
};

export const renewPasswordGtmEvents = {
	genericFormCancel: "GenericFormCancel",
	virtualPageView: "VirtualPageView",
};
